import { toast } from "react-hot-toast";

function postCrossDomainMessage(token, data) {
  if (process.env.REACT_APP_ENV === "local") {
    document.cookie = `${process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_TOKEN_KEY}=${token};`;
    document.cookie = `${
      process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA
    }=${JSON.stringify(data)} ; `;
  } else {
    document.cookie = `${process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_TOKEN_KEY}=${token}; domain=tripmerchant.ca; SameSite=Strict; secure`;
    document.cookie = `${
      process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA
    }=${JSON.stringify(data)}; domain=tripmerchant.ca; SameSite=Strict; secure`;
  }
  /*  window.location.replace(
    process.env.REACT_APP_ENV === "local"
      ? "http://localhost:3001"
      : process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_URL
  ); */
}

export default postCrossDomainMessage;

export const RemoveCookie = () => {
  document.cookie =
    process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_TOKEN_KEY +
    "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  document.cookie =
    process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA +
    "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

export const  removeSharedCookie = () => {
  const sharedDomain =  process.env.REACT_APP_TRIP_SHARED_DOMAIN
  document.cookie = `${'text'}=; path=/; domain=${sharedDomain}; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
  document.cookie = `${process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA}=; path=/; domain=${sharedDomain}; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
  document.cookie = `${process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_DOMAIN}=; path=/; domain=${sharedDomain}; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
}

export const decodeCookie = (cname) => {
  const name = `${cname}`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const DomainRedirection = (token, domain) => {
  let url;
  if (process.env.REACT_APP_ENV === "local") {
    url =
      domain !== null &&
      domain !== undefined &&
      domain !== "members.tripmerchant.com"
        ? `http://${domain}.localhost:3001`
        : `http://localhost:3001`;
  } else if (process.env.REACT_APP_ENV === "staging") {
    url = `https://staging-tour.tripmerchant.com`;
  } else {
    url =
      domain !== null &&
      domain !== undefined &&
      domain.includes("tripmerchant.com")
        ? `https://${domain}`
        : `https://${domain}.tripmerchant.com`;
  }
  const queryParams = new URLSearchParams(window.location.search);
  const redirect = queryParams.get("redirect")
  /* if (url !== "" || url !== null || url !== undefined) */
  window.location.replace(`${url}/verify?redirect=${redirect ? redirect : '/'}&token=${token}`);
};

export const GetLogInInfo = () => {
  if (
    process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA !==
      "undefined" &&
    process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA !== "undefined"
  ) {
    let token = decodeCookie(
      process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_TOKEN_KEY
    ).slice(1);
    let userData = decodeCookie(
      process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA
    )
      ? JSON?.parse(
          decodeCookie(
            process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA
          ).slice(1)
        )
      : "";
    if (token !== "" && userData !== "") {
      DomainRedirection(token, userData?.domain);
      toast.dismiss();
      toast.success("Already LoggedIn");
    } else {
      RemoveCookie();
    }
  } else {
    RemoveCookie();
  }
};

// export const redirectToOrganizationDomain = (response) => {
//   let token = response?.meta?.token;
//   let domain = response?.data?.organization?.domain;
//   const cookieDomain = ".alpha.com"; // Replace with your actual root domain
//   document.cookie = `${process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_TOKEN_KEY}=${response?.meta?.token};`;
//   document.cookie = `${
//     process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA
//   }=${JSON.stringify(response?.data)} ; `;
//   // DomainRedirection(token, domain);
//
//   console.log('============================')
//   console.log('Toke',token)
//   console.log('domain',domain)
//   console.log('============================')
// };

export const redirectToOrganizationDomain = (response) => {
  const token = response?.meta?.token;
  const domain = response?.data?.organization?.domain;
  const sharedDomain =  process.env.REACT_APP_TRIP_SHARED_DOMAIN
  const expires = new Date();
  expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000);
  const expiresString = expires.toUTCString();

  console.log('===============Domain Check================')
  console.log('sharedDomain',sharedDomain)
  console.log('===============Domain Check================')
  console.log('===============Env Domain Check================')
  console.log('Env Domain',process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_DOMAIN)
  console.log('===============Domain Check================')
  document.cookie = `${'text'}=${encodeURIComponent(token)}; path=/; domain=${sharedDomain};expires=${expiresString}`;
  document.cookie = `${process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_DOMAIN}=${encodeURIComponent(domain)}; path=/; domain=${sharedDomain};expires=${expiresString}`;

  // Set cookie for token
  document.cookie = `${process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_TOKEN_KEY}=${encodeURIComponent(token)}; path=/; `;
  document.cookie = `${process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA}=${encodeURIComponent(
      JSON.stringify(response?.data)
  )}; path=/;`;

  // Optional: Uncomment this when you want redirection to happen
  DomainRedirection(token, domain); 
};

export const checkAndRedirectToOrganizationDomain = () => {
  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  };

  const token = getCookie('text');
  const domain = getCookie(process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_DOMAIN);
  console.log('token',token);
  console.log('userDataRaw',domain);
  if (token && domain) {
    try {
        DomainRedirection(token, domain);
    } catch (err) {
      console.error('Failed to parse user data:', err);
    }
  }
};
